:host {
  /**
   * @prop --border-radius: Border radius of the avatar and inner image
   */
  border-radius: var(--border-radius);
  display: block;
}

::slotted(ion-img),
::slotted(img) {
  border-radius: var(--border-radius);
  width: 100%;
  height: 100%;
  object-fit: cover;
  overflow: hidden;
}

:host {
  --border-radius: 50%;
  width: 64px;
  height: 64px;
}